import { TemplateLink } from "./TemplateLink"

export default function SailboatContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        Sailboat comes from Luke Hohmann's <em>Innovation Games</em> (2006),
        a book that argued serious business questions get better answers
        when you dress them up as play. The metaphor: your team is a
        sailboat. Wind pushes you forward, anchors hold you back, rocks are
        the risks you can see just under the surface, and the island on the
        horizon is where you're trying to go.
      </p>

      <h2>When to use this format</h2>
      <p>
        Reach for it when the team feels stuck in a rut of{" "}
        <TemplateLink to="start-stop-continue">Start / Stop / Continue</TemplateLink>{" "}
        muscle memory. The metaphor forces a different kind of thinking; you
        can't answer "what are our anchors" with the same list you'd write
        for "what should we stop." It also plays well with mixed-discipline
        retros, where non-engineers tend to enjoy the visual framing more
        than a plain grid.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Skip it if your team hates metaphors. Some engineers roll their eyes
        at the whole thing, and eye-rolls are contagious. Skip it, too, if
        you have less than 30 minutes; the format asks people to translate
        their experience into a metaphor first, and that translation takes
        time.
      </p>

      <h2>How to run it</h2>
      <p>
        Draw the boat on the board or share the columns as-is. Give the team
        ten minutes of silent writing. Discuss rocks first (hidden risks lose
        their power the moment they get named), then anchors, wind, and
        finally the island. Long-form retros like this tend to lose their
        social energy fast on video calls; Retroboard's avatars keep it
        visible who's contributing and who's gone quiet.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        Teams get so into the metaphor they forget to translate it back to
        actions. "The wind is our new deploy pipeline." Great, but what
        does that mean you're going to do differently on Monday? The
        metaphor is a thinking tool, not a deliverable.
      </p>
    </>
  )
}
